export function isRequiredRule(rule: unknown): boolean {
  return (
    typeof rule === 'object' &&
    rule !== null &&
    'required' in rule &&
    !!(rule as { required?: boolean }).required
  );
}
